import { Suspense, useEffect } from 'react';
import { AppShell as MantineAppShell, Group, Text, Burger, Center, Loader } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet, useLocation } from 'react-router-dom';
import { UserBar } from '../components/UserBar.jsx';
import { RoleSidebar } from '../components/RoleSidebar.jsx';
import { ActingAsBanner } from '../components/ActingAsBanner.jsx';

export function AppShell() {
    const [opened, { toggle, close }] = useDisclosure();
    const location = useLocation();

    // Закрываем мобильный сайдбар при смене страницы (чтобы юзер не видел его поверх контента).
    useEffect(() => {
        close();
    }, [location.pathname, close]);

    return (
        <MantineAppShell
            header={{ height: 60 }}
            navbar={{
                width: 260,
                breakpoint: 'sm',
                collapsed: { mobile: !opened },
            }}
            padding="md"
        >
            <MantineAppShell.Header>
                <Group h="100%" px="md" justify="space-between" wrap="nowrap">
                    <Group gap="sm" wrap="nowrap">
                        <Burger
                            opened={opened}
                            onClick={toggle}
                            hiddenFrom="sm"
                            size="sm"
                            aria-label="Меню"
                        />
                        <Text fw={600} size="lg" lineClamp={1}>
                            AI-тренажёр для оконщиков
                        </Text>
                    </Group>
                    <UserBar />
                </Group>
            </MantineAppShell.Header>

            <MantineAppShell.Navbar p="md">
                <RoleSidebar />
            </MantineAppShell.Navbar>

            <MantineAppShell.Main>
                {/* Банер View-as — виден только Создателю в режиме «Войти как»
                    (см. TZ §5.11). Рендерим внутри Main, чтобы он скроллился
                    вместе с контентом (sticky сверху). */}
                <ActingAsBanner />
                {/* Suspense — для code-split страниц (React.lazy в App.jsx).
                    Когда юзер переходит на страницу первый раз — рендерим лоадер,
                    пока chunk скачается. Дальше chunk кэшируется. */}
                <Suspense
                    fallback={
                        <Center py="xl">
                            <Loader />
                        </Center>
                    }
                >
                    <Outlet />
                </Suspense>
            </MantineAppShell.Main>
        </MantineAppShell>
    );
}
